/**
 * --------------------------------------------------
 * components/PasswordTemplate.ts
 * Password
 * --------------------------------------------------
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class PasswordTemplate extends ThemeComponent {
    @Ref() passwordToggle!: HTMLButtonElement;
    @Ref() passwordForm!: HTMLElement;

    init() {
        this.setEventListeners();
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        this.$listen(this.passwordToggle, 'click', () => {
            this.passwordToggle.classList.remove('password__toggle--active');
            this.passwordForm.classList.add('password__form--active');
        });
    }
}
